import { isInTauriShell, getPlatformFallback } from './detector'
import { invokeTauri } from './bridge'
import type { RuntimeInfo } from './types'

/**
 * Returns runtime info. In Tauri shell, calls native get_runtime_info; in browser, returns synthetic info.
 */
export async function getRuntimeInfo(): Promise<RuntimeInfo> {
  if (!isInTauriShell()) {
    return {
      runtime: 'browser',
      platform: getPlatformFallback(),
      capabilities: {
        silentPrint: false,
        printerDiscovery: false,
        fileDownload: true, // browser can trigger downloads via anchor
      },
    }
  }

  const raw = await invokeTauri<{
    runtime: string
    platform: string
    appVersion: string
    capabilities: {
      silentPrint: boolean
      printerDiscovery: boolean
      fileDownload: boolean
      thermalPrint?: boolean
      thermalSilent?: boolean
      thermalDiscovery?: boolean
    }
  }>('get_runtime_info')

  return {
    runtime: 'tauri',
    platform: raw.platform as RuntimeInfo['platform'],
    appVersion: raw.appVersion,
    capabilities: {
      silentPrint: raw.capabilities.silentPrint,
      printerDiscovery: raw.capabilities.printerDiscovery,
      fileDownload: raw.capabilities.fileDownload,
      thermalPrint: raw.capabilities.thermalPrint ?? false,
      thermalSilent: raw.capabilities.thermalSilent ?? false,
      thermalDiscovery: raw.capabilities.thermalDiscovery ?? false,
    },
  }
}
